import React, { ReactNode, FC, useContext, MouseEvent } from 'react';
import { WithTranslation } from 'react-i18next';

import { SCP } from 'ia-react-core/~/interfaces/SCP';
import PrimaryButton from '../../buttons/PrimaryButton';

import { StyledWrapper, StyledTitle, StyledErrorMessage, StyledActionBar, StyledText } from './PageErrorMessage.styles';
import MainContentContext from '../../layout/#MainContentContext';
import { ReactComponent as ErrorIcon } from './assets/robot.svg';

export interface PageErrorMessageProps extends SCP<'div'>{
  /** The content to display when there is no error */
  children?: ReactNode;
  /** Custom error message */
  message?: ReactNode;
  /** The title of the error */
  errorTitle?: ReactNode;
  /** Text of the retry button. If not defined, no error button will display */
  buttonText?: ReactNode;
  /** Callback of the retry button */
  onButtonClick?: (event: MouseEvent<HTMLButtonElement>) => void;
}

interface PageErrorMessageInternalProps extends WithTranslation{}

export interface PageErrorMessageComposedProps extends PageErrorMessageProps, PageErrorMessageInternalProps {

}

const PageErrorMessage: FC<PageErrorMessageComposedProps> = ({ errorTitle, children, message, t, buttonText, onButtonClick, ...props }) => {
  const { paddingTop: paddingTopContent } = useContext(MainContentContext);
  return (
    <StyledWrapper paddingTopContent={paddingTopContent} {...props}>
      <StyledErrorMessage>
        <ErrorIcon />
        <StyledTitle>{errorTitle || t('title')}</StyledTitle>
        <StyledText>{message || t('error')}</StyledText>
        {buttonText ? (
          <StyledActionBar>
            <PrimaryButton
              data-testid="ErrorBoundaryButton"
              onClick={onButtonClick}
            >{buttonText}
            </PrimaryButton>
          </StyledActionBar>
        ) : null}
      </StyledErrorMessage>
    </StyledWrapper>
  );
};

export default PageErrorMessage;
